import classNames from "classnames";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import { useLocation } from "react-router-dom";
import { RootState } from "../../redux/store";
import MatrixChat from "../main/matrix-chat/MatrixChat";
import { environment } from "../../config/environments/environment";
import { useTheme } from "../../../context/ThemeContext";
const MEETING_PANEL_REDIRECT_KEY = "vcon_meeting_panel_subscription_redirect";
export default function Layout({ children, ...props }: any) {
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("from") !== "meeting-panel") {
      return;
    }
    const token = Cookies.get("auth_token");
    if (!token) {
      window.location.assign("/");
      return;
    }
    if (sessionStorage.getItem(MEETING_PANEL_REDIRECT_KEY)) {
      return;
    }
    sessionStorage.setItem(MEETING_PANEL_REDIRECT_KEY, "1");
    const target = `${environment.meetingPanelSubscriptionHandoffUrl}${encodeURIComponent(token)}`;
    window.location.assign(target);
  }, [location.search]);

  // Check if the current route is '/chat'
  const showMatrix = useSelector((state: RootState) => state.matrix.showMatrix);

  const shouldDisplayMatrixChat = useSelector(
    (state: RootState) => state.matrix.isChatVisible
  );

  const { themeClassName } = useTheme();

  return (
    <div className={`cnv-wrapper ${themeClassName}`}>
      {props.from !== "orgDelete" ? <Sidebar /> : ""}
      <div className="cnv-content-area">
        <Header />
        <div
          className={classNames({
            "cnv-content-chat": showMatrix,
            "cnv-content": !showMatrix,
          })}
        >
          {/* {shouldDisplayMatrixChat && (
            <div className="cnv-chat-wrapper">
              <div
                style={showMatrix ? { display: "block" } : { display: "none" }}
              >
                <MatrixChat />
              </div>
            </div>
          )} */}
          <div id="portalForModal" style={{ position: "relative" }}>
            <div className="cnv-content-container">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
